import { MaxBrainExperience } from '../models/experience.model';

export class AddExperiences {
    static readonly type = '[Experience] AddExperience';

    constructor(public payload: MaxBrainExperience[]) {}
}
